import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';
import { ADMIN_AI_LOCAL_API_REQUESTS } from './constants';

/**
 * GET /legacy_admin/ai/usage?from=YYYY-MM-DD&to=YYYY-MM-DD — both days inclusive,
 * UTC; system admin only.
 */
export const getAdminAiUsage = async ({ from, to }) => {
  const signedRequest = await createSignedGetRequest({
    apiPath: `legacy_admin/ai/usage?from=${encodeURIComponent(
      from
    )}&to=${encodeURIComponent(to)}`,
    isLocalApiRequest: ADMIN_AI_LOCAL_API_REQUESTS,
  });
  const response = await axios(signedRequest);
  return response.data;
};
